import { DateFormat, jodaFormatPatternWithLocale } from '@ftr/foundation'
import { LocalTimeRange } from '@ftr/regional-api-contracts'

export const CART_TIME_FORMAT = jodaFormatPatternWithLocale(DateFormat.TimeWithSeconds)

export function formatCartTime(timeRange: LocalTimeRange): string {
  return `${timeRange.start.format(CART_TIME_FORMAT)} - ${timeRange.end.format(CART_TIME_FORMAT)}`
}
